module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_004.ec4df360.mp3";